import React from 'react';
import {
  Box,
  Button,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Text,
  Icon,
} from '@chakra-ui/react';
import { MdBuild, MdExpandMore } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { t } from '#i18n';
import { useAccount } from '#contexts/account';
import { PermissionsRequiredWarning } from '#components';

import { InstallationCell } from './InstallationCell';

const ORGANIZATIONS_SETTINGS_PATH = '/settings/organizations';

export const OrganizationsSelect = ({ ...props }) => {
  const navigate = useNavigate();
  const { installations, currentInstallation, setCurrentInstallation } = useAccount();

  return (
    <Box {...props}>
      <Menu>
        <MenuButton
          as={Button}
          variant="outline"
          width="full"
          fontWeight="medium"
          rightIcon={<MdExpandMore />}
        >
          {currentInstallation
            ? <InstallationCell installation={currentInstallation} />
            : t('navmenu.organizationsSelect.title')}
        </MenuButton>
        <MenuList>
          {installations?.map((installation) => (
            <MenuItem key={installation.id} onClick={() => setCurrentInstallation(installation)}>
              <InstallationCell installation={installation} />
            </MenuItem>
          ))}
          <MenuItem onClick={() => navigate(ORGANIZATIONS_SETTINGS_PATH)}>
            <Icon as={MdBuild} marginRight={3} boxSize={5} />
            <Text fontSize="sm">
              {t('navmenu.organizationsSelect.manage')}
            </Text>
          </MenuItem>
        </MenuList>
      </Menu>
      {currentInstallation
        && currentInstallation.status !== 'ACTIVE'
        && currentInstallation.status !== 'SYNCING'
        && (
        <PermissionsRequiredWarning
          variant="left-accent"
          margin="1rem 0 0"
          message={t('alerts.permissionsRequired.short')}
          permissionsGrantUrl={currentInstallation?.manageUrl}
        />
        )}
    </Box>
  );
};
